import React, { useState, } from 'react';
import Select from 'react-select';
import Env from '../../hooks/Env';
import { useNavigate, useLocation } from 'react-router-dom';
import './Pay.css';
import logo from '../../img/logo_uam.png'
import wave from '../../img/wave.jpg'
import om from '../../img/OM.jpg'
import axios from 'axios';
import freemoney from '../../img/free-money.jpg'
import expresso from '../../img/expresso.jpg'
import bank from'../../img/carte-bancaire-50px.svg';
import yas from '../../img/yas.jpeg'
import {Link} from 'react-router-dom';
import { Image, Form,Container,Button,Spinner } from 'react-bootstrap';
import IdTransaction from '../../components/idTransaction/IdTransaction';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan } from "@fortawesome/free-solid-svg-icons";
import AlerteMessage from '../../components/AlerteMessage';
import { useEffect } from 'react';
import Input from '../../components/Input';
import InputT from '../../components/Input';
import { InputF } from '../../components/Input';
import guide from '../../docs/Mode opératoire.pdf'
import brochure from '../../docs/brochure.pdf'
import RecepisseConcours from '../../components/Recepisse';
import UpdateDepot from '../../components/UpdateDepot';
import moment from 'moment';
import { bacSeries } from '../../constants/bacSeries';
import useDocumentTitle from '../../hooks/useDocumentTitle';

function Pay ({prix}) {
    useDocumentTitle('CONCOURS D\'ENTREE EDITION 2026');
    const { API_URL } = Env();
    const [bacSerie, setBacSerie] = useState('');
    const [choices, setChoices] = useState({});
    const [totalChoices, setTotalChoices] = useState(0);
    const [firstChoiceType, setFirstChoiceType] = useState('');
    const [data, setData] = useState('');
    const [departementsAvecFilieres, setDepartementsAvecFilieres] = useState([]);
    const [centresExamenList, setCentresExamenList] = useState([]);

    useEffect(() => {
        axios.get(`${API_URL}/filiere/concours-options`)
            .then(response => setDepartementsAvecFilieres(response.data))
            .catch(error => console.error('Erreur lors de la récupération des filières:', error));
        axios.get(`${API_URL}/centre_examen/`)
            .then(response => setCentresExamenList(response.data))
            .catch(error => console.error('Erreur lors de la récupération des centres d\'examen:', error));
    }, [API_URL]);

    const departments = {
        scientifique: departementsAvecFilieres.filter(d => d.departement.type === 'scientifique').map(d => d.departement.code),
        litteraire: departementsAvecFilieres.filter(d => d.departement.type === 'litteraire').map(d => d.departement.code),
    };

    const concoursCenters = [
        { value: '', label: '--- Veuiller choisir un centre ---' },
        ...centresExamenList.map(c => ({ value: c.libelle, label: c.libelle })),
    ];

    const departementsOptions = [
        { value: '', label: '--- Choisir un département ---' },
        { value: 'Dakar', label: 'Dakar' },
        { value: 'Guediawaye', label: 'Guediawaye' },
        { value: 'Pikine', label: 'Pikine' },
        { value: 'Keur Massar', label: 'Keur Massar' },
        { value: 'Rufisque', label: 'Rufisque' },
    ];
    const handleSerieChange = (e) => {
        data.premier_choix_ecole = '';
        data.second_choix_ecole = '';
        data.troisieme_choix_ecole = '';
        data.quatrieme_choix_ecole = '';
        setBacSerie(e.target.value);
        setData({ ...data, 'serie': e.target.value});
    setChoices({});
    setOrderedChoices([]);
    setTotalChoices(0);
    setFirstChoiceType('');
    };
var choix_par_ordre = ['premier_choix_ecole', 'second_choix_ecole', 'troisieme_choix_ecole','quatrieme_choix_ecole'];
const [orderedChoices, setOrderedChoices] = useState([]);

const handleFiliereChange = (department, filiere, deptType) => {
    setChoices((prevChoices) => {
        const deptChoices = prevChoices[department] || [];
        let newChoices;
        let newTotalChoices = totalChoices;

        if (deptChoices.includes(filiere)) {
            // Supprimer le choix
            const newDeptChoices = deptChoices.filter((f) => f !== filiere);
            newTotalChoices -= 1;
            newChoices = { ...prevChoices, [department]: newDeptChoices };

            // Mise à jour de l'ordre des choix
            const updatedOrderedChoices = orderedChoices.filter(choice => !(choice.department === department && choice.filiere === filiere));
            setOrderedChoices(updatedOrderedChoices);

            // Mise à jour de l'état des données
            const updatedData = { ...data };
            choix_par_ordre.forEach((key, index) => {
                console.log(key,index)
                updatedData[key] = updatedOrderedChoices[index]?.filiere || '';
            });
            setData(updatedData);
        } else {
            if (newTotalChoices < 4 && deptChoices.length < 2) {
                if (newTotalChoices === 0) {
                    setFirstChoiceType(deptType);
                } else if (firstChoiceType && firstChoiceType !== deptType) {
                    return prevChoices;
                }
                const newDeptChoices = [...deptChoices, filiere];
                newTotalChoices += 1;
                newChoices = { ...prevChoices, [department]: newDeptChoices };

                // Ajouter le nouveau choix à la fin de l'ordre des choix
                const updatedOrderedChoices = [...orderedChoices, { department, filiere }];
                setOrderedChoices(updatedOrderedChoices);

                // Mise à jour de l'état des données
                const updatedData = { ...data };
                choix_par_ordre.forEach((key, index) => {
                    updatedData[key] = updatedOrderedChoices[index]?.filiere || '';
                });
                setData(updatedData);
            } else {
                return prevChoices;
            }
        }
        setTotalChoices(newTotalChoices);
        return newChoices;
    });
};

const renderDepartments = (deptType) => {
    return departementsAvecFilieres
        .filter(({ departement }) => departement.type === deptType)
        .map(({ departement, filieres: filieresDuDepartement }) => (
        <div key={departement.code}>
            <span className='fw-medium'>{departement.libelle}</span>
            {filieresDuDepartement
                .filter((f) => !f.series_autorisees || f.series_autorisees.split(',').includes(bacSerie))
                .map((f) => (
                <div key={f.nom} className='form-check'>
                    <input
                        type="checkbox"
                        className='form-check-input'
                        id={`${departement.code}-${f.nom}`}
                        value={f.nom}
                        checked={choices[departement.code]?.includes(f.nom) || false}
                        onChange={() => handleFiliereChange(departement.code, f.nom, deptType)}
                        disabled={
                            (!choices[departement.code]?.includes(f.nom) && totalChoices >= 4) ||
                            (firstChoiceType && firstChoiceType !== deptType) || (!choices[departement.code]?.includes(f.nom) && totalChoices >= 2 && deptType === 'litteraire')
                        }
                    />
                    <label className='form-check-label' htmlFor={`${departement.code}-${f.nom}`}>{f.nom}</label>
                </div>
            ))}
        </div>
    ));
};
    const { search } = useLocation();
    const [showPay, setShowPay] = useState(false);
    const maxFileSize = 1024 * 1024;
    const [erreurMoyenne, setErreurMoyenne] = useState(false);
    const [complete, setComplete] = useState(false);
    const [requiredOK, setRequiredOk] = useState(true);
    const [selectedFiles, setSelectedFiles] = useState({
        "releve_bac":true,
        "copie_carte_id" : true,
        "bulletin_terminal" : true,
        "bulletin_premiere" : true,
        "bulletin_seconde" : true,
        "bulletin_premiere2" : true,
        "bulletin_seconde2" : true,
        "bulletin_terminal2" : true,
    });
    const [gestionfichier, setGestionFichier] = useState({  
        "bulletin_premiere2" : false,
        "bulletin_seconde2" : false,
        "bulletin_terminal2" : false
    });
    const [nationalities, setNationalities] = useState([]);
    const [controllerChoice, setControllerChoice] = useState(false)
    const [errors, setErrors] = useState(false);
    const [step, setStep] = useState(1);
    const [nmbrechoix, setNombreChoix] = useState(false)
    const[ messageAlerte, setMessageAlerte] = useState('');
    const [showMessage, setShowMessage] = useState(false);
    const [showMessageEmail, setShowMessageEmail] = useState(false);
    const [show, setShow] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [checked, SetChecked] = useState(false);
    const [open, setOpen] = useState (false);
    const [message, setMessage] = useState (false);
    const [valid, SetIsValid] = useState({
        isValidEmail: false,
        isValidPhoneNumber: false,
      });
      const [older,setOlder] = useState(false);
      const [showUpdate, setShowUpdate] = useState(false);
      const handleCloseUpdate = () => {
        setShowUpdate(false);
      }
    const handleChange = (e) => {
        const name= e.target.name;
        let value = e.target.value;
        if (name === 'telephone') {
            const phoneRegex = /^(70|75|76|77|78|71)\d{7}$/;
            const isValidPhoneNumber = phoneRegex.test(value);
        
            SetIsValid((valid) => ({
                ...valid,
                isValidPhoneNumber: isValidPhoneNumber,
            }));
            setShowMessage(true);
        }
        if (name==="nom") {
            let nom  = value.toUpperCase()
            value = nom
            // console.log(nom)
        }
        if (name==="date_naissance") {
            const referenceDate = moment('2024-12-31');
            const dateNaissance = moment(value); // Remplacez cela par la date de naissance réelle
            const ageCalcul = referenceDate.diff(dateNaissance, 'years')
          const maxAge = 22;
          if (ageCalcul > maxAge || ageCalcul < 14) {
            setOlder(true)
            setData({ ...data, [name]: value });
            return
          } else {
            setOlder(false)
          }
        }
        if (name === 'email') {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            SetIsValid((valid) => ({
                ...valid,
                isValidEmail: emailRegex.test(value),
            }));
            setShowMessageEmail(true)
        }
        if (name === 'operateur') {
            SetChecked(e.target.checked)
        }
        setData({ ...data, [name]: value })
    }
    const handleClose3 = () => {
        setOpen(false)
    }
    const [photo, setPhoto] = useState(false);
    const handleFileChange = (event, key) => {
        const elements = document.getElementsByName(key)
        let file = event.target.files[0];
        if (file && file.type !== 'application/pdf') {
            setSelectedFiles((prevSelectedFiles) => ({
                ...prevSelectedFiles,
                [key]: false
            }));
            setGestionFichier((prevSelectedFiles) => ({
                ...prevSelectedFiles,
                [key]: false
            }));
            setPhoto(true);
            setOpen(true)
            setMessage("Seul le format pdf est autorisé !")
            event.target.value = '';
            return ;
        }
        if (file?.size < maxFileSize){
            if (key !== 'photo') {
                if (file.type ==='application/pdf') {
                    if (!data.nom || !data.prenom) {
                    setOpen(true)
                    setMessage("Veuiller renseigner d'abord le nom et prénom !");
                    event.target.value = '';
                    return
                    }
                    data.nom = data.nom.trim()
                    data.prenom = data.prenom.trim()
                    var filesinfos = file.slice(0, file.size, 'application/pdf'); 
                    file = new File([filesinfos], `${key+"_"+data.prenom+"_"+data.nom}.pdf`, {type: 'application/pdf'});
                    setPhoto(false)
                    setSelectedFiles((prevSelectedFiles) => ({
                        ...prevSelectedFiles,
                        [key]: file
                    }));
                    setGestionFichier((prevSelectedFiles) => ({
                        ...prevSelectedFiles,
                        [key]: true
                    }));
                    for (var i = 0; i < elements.length; i++) {
                        var element1 = elements[i];
                        element1.style.border = "";
                    }
                } else {
                    setPhoto(true)
                    setOpen(true)
                    setMessage("format de fichier non permis")
                    // console.log("format de fichier non permis ")
                    setGestionFichier((prevSelectedFiles) => ({
                        ...prevSelectedFiles,
                        [key]: false
                    }));
                    return
                }   
            } else {
                // console.log(file)
                setSelectedFiles((prevSelectedFiles) => ({
                    ...prevSelectedFiles,
                    [key]: file
                }));
                setGestionFichier((prevSelectedFiles) => ({
                    ...prevSelectedFiles,
                    [key]: true
                }));
                for (var J = 0; J < elements.length; J++) {
                    var element = elements[J];
                    element.style.border = ""; // Applique une bordure rouge
                }
            }
        } else {
            // console.log('fichier top gros !')
            setSelectedFiles((prevSelectedFiles) => ({
                ...prevSelectedFiles,
                [key]: false
            }));
            setGestionFichier((prevSelectedFiles) => ({
                ...prevSelectedFiles,
                [key]: false
            }));
            for (var j = 0; j < elements.length; j++) {
                var element2 = elements[j];
                element2.style.border = "2px solid #BC0C0C";
                element2.style.transition ='border 0.5s ease-in-out;' // Applique une bordure roug
            }
            setSelectedFiles((prevSelectedFiles) => ({
                ...prevSelectedFiles,
                [key]: false
            }));
            setGestionFichier((prevSelectedFiles) => ({
                ...prevSelectedFiles,
                [key]: false
            }));
            setPhoto(true);
            setOpen(true)
            setMessage("Le fichier chargé est supérieur à 1 Mo")
            event.target.value = '';
            return ;
        }
    };
    let NotComplete = true;
    if (!valid.isValidEmail || !valid.isValidPhoneNumber || !checked || older) {
        NotComplete = false;
    }
      const handlePreviousStep = () => {
        setStep(step - 1);
      };
      const handleNextStep = () => {
        if (step === 1) {
            if (!data.telephone || !data.email || !data.numero_table || !data.operateur || !data.date_naissance) {
                setErrors(true);
                return ;
            } else {
                fetch(`${API_URL}/bac/?numero_table=${data.numero_table}&date=${data.date_naissance}`)
                .then(response => response.json())
                .then(datas => {
                if (datas.detail) {
                    console.log('datas', datas.detail)
                    setOpen(true)
                    setMessage(datas.detail);
                    return ;
                } else if (datas.message) {
                    setOpen(true)
                    setMessage(data.message);
                    return ;
                }
                setErrors(false);
                setOlder(false);
                console.log(datas)
                const infos_candidat = datas
                data.prenom = infos_candidat.prenom;
                data.nom = infos_candidat.nom;
                data.date_naissance = infos_candidat.date_naissance;
                data.civilite = infos_candidat.civilite;
                data.civilite ? SetChecked(true) : SetChecked(false);
                data.lieu_naissance = infos_candidat.lieu_naissance;
                // data.address = infos_candidat.adress;
                // data.address=""
                setBacSerie(infos_candidat.serie_bac);
                data.serie = infos_candidat.serie_bac;
                
                // Calcul de la moyenne terminale avec gestion des valeurs nulles/inexistantes
                const moyenneS1 = infos_candidat.moyenne_terminal_s1 || 0;
                const moyenneS2 = infos_candidat.moyenne_terminal_s2 || 0;
                
                if (moyenneS1 > 0 && moyenneS2 > 0) {
                    data.moyenne_terminal = parseFloat(((moyenneS1 + moyenneS2) / 2).toFixed(2));
                } else if (moyenneS1 > 0) {
                    data.moyenne_terminal = parseFloat(moyenneS1.toFixed(2));
                } else if (moyenneS2 > 0) {
                    data.moyenne_terminal = parseFloat(moyenneS2.toFixed(2));
                } else {
                    data.moyenne_terminal = 0;
                }
                
                data.moyenne_premiere = infos_candidat.moyenne_premiere ;
                data.moyenne_seconde = infos_candidat.moyenne_seconde ;
                 setStep(step + 1);
                 data.moyenne_bac = infos_candidat.moyenne_bac;
                 data.session = infos_candidat.session_bac;
                 data.lycee_ecole = infos_candidat.lycee_ecole;
                 setStep(step + 1);
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                    setOpen(true)
                    setMessage('Impossible de récupérer les données du bac !')
                });
        }
    } else if (step === 2) {
        setStep(step + 1);
    }
}
    const [payEmail, setPayEmail] = useState('');
    const [succes,setSucces] = useState(false);
    const [auth, setAuth] = useState(false);
    const [depotsuccess, setDeppotSuccess] = useState(false);
    const navigate = useNavigate();
    const [user,setUser] = useState('');
    useEffect(() => {
           function hasAtLeastOneFilierePerDept(choices, deptList) {
        return deptList.every(dept => Array.isArray(choices[dept]) && choices[dept].length > 0);
    }
        const user = search.match(/user=([^&]*)/);
        if (user && user[1]) {
            setUser(user[1]);
            setData({ ...data, email: user[1] });
            setAuth(true);
            SetIsValid((valid) => ({
                ...valid,
                isValidEmail: true,
            }));
        }
        // console.log(emailFromURL)
        // console.log(firstChoiceType);
        // console.log(choices)
        const match = search.match(/email=(.*)/);
        const emailFromURL = match?.[1];
        // console.log(emailFromURL)
        if (emailFromURL){
            axios({
                url:`${API_URL}/paiement/confirmed/`,
                method: 'POST',
                data:{
                    'email':emailFromURL
                }
            })
            .then(result => {
                if (result.data.confirmed_depot === 0) {
                    setDeppotSuccess(true)
                    setSucces(result.data)
                    return
                }
                else if (result.data.campagne==='reinscription' || result.data.campagne==='master') {
                    navigate(`/`);
                }
                 else {
                    navigate('/')
                }
            })
            .catch((error) => {
                console.error(error)
            });
      }
    //   console.log(data)
        if (data.serie === 'L2' && (getDepartementByFiliere(data.premier_choix_ecole) ==='DGO' || getDepartementByFiliere(data.second_choix_ecole) ==='DGO') && data.moyenne_terminal < 12) {
            setPhoto(true);
            setOpen(true);
            setMessage('Une moyenne de 12 est requis en terminale!')
            setErreurMoyenne(true);
            return 
        } else {
            setOpen(false)
            setPhoto(false)
            setErreurMoyenne(false);
        }
        if (firstChoiceType==='litteraire') {
            if ((!data.premier_choix_ecole || !data.second_choix_ecole) && (bacSerie==='L2')) {
                if (data.moyenne_terminal < 12) {
                    setNombreChoix(true)
                } else {
                    setNombreChoix(true)
                }
            } else {
                setNombreChoix(false)
            }
            if (getDepartementByFiliere(data.premier_choix_ecole) ==='DGO' && getDepartementByFiliere(data.second_choix_ecole)==='DGO' ) {
                // console.log('impossible de le faire ')
                // setControllerChoice(true)
            }
            else if ((getDepartementByFiliere(data.premier_choix_ecole) ==='DU2ADT' && getDepartementByFiliere(data.second_choix_ecole)==='DU2ADT')) {
                console.log('impossible de le faire ')
                // setControllerChoice(true)
            } else {
                setControllerChoice(false)
            }
        }
        function getDepartementByFiliere(filiere) {
            for (const { departement, filieres: filieresDuDepartement } of departementsAvecFilieres) {
                if (filieresDuDepartement.some((f) => f.nom === filiere)) {
                    return departement.code;
                }
            }
            return null; // Retourne null si la filière n'est pas trouvée
        }
        const departement1 = getDepartementByFiliere(data.premier_choix_ecole) ===null ? '' :  getDepartementByFiliere(data.premier_choix_ecole);
        const departement2 = getDepartementByFiliere(data.second_choix_ecole) ===null ? '' :  getDepartementByFiliere(data.second_choix_ecole);
        const departement3 = getDepartementByFiliere(data.troisieme_choix_ecole) ===null ? '' :  getDepartementByFiliere(data.troisieme_choix_ecole);
        const departement4 = getDepartementByFiliere(data.quatrieme_choix_ecole) ===null ? '' :  getDepartementByFiliere(data.quatrieme_choix_ecole);
        const controller = []
        if (departement1 && departement2 && departement3 && departement4) {
            controller.push(departement1,departement2,departement3,departement4);
        }
        function countOccurrences(element) {
            let count = 0;
            for (let i = 0; i < controller.length; i++) {
                if (controller[i] === element) {
                    count++;
                }
                // console.log(count)
            }
            if( count === 2 ) {
                return count;
            } else {
                setControllerChoice(false);
            }
        }
        // console.log(controller)
        if (controller.length===4) {
            if (countOccurrences(departement1) === countOccurrences(departement2) || countOccurrences(departement1) === countOccurrences(departement3) || countOccurrences(departement1) === countOccurrences(departement4) ||  countOccurrences(departement2) === countOccurrences(departement4)  ||  countOccurrences(departement3) === countOccurrences(departement2)) {
                if (countOccurrences(departement1)===2 && countOccurrences(departement2) ===2 && countOccurrences(departement3) && countOccurrences(departement4)) {
                    // console.log("choix pas possible " +departement1,departement2,departement3,departement4)
                    setControllerChoice(true)
                } else {
                    // console.log("choix possible ")
                    setControllerChoice(false)
                }
            } else {
                // console.log("choix bien possible")
                setControllerChoice(false)
            }
            // alert('choix de deux départements impossible ')
        }
        if (showMessage) {
            const timer = setTimeout(() => {
                setShowMessage(false);
            }, 1000); // 2 seconds
            return () => clearTimeout(timer);
        }
        if (showMessageEmail) {
            const timer = setTimeout(() => {
                setShowMessageEmail(false);
            }, 1000); // 2 seconds
            return () => clearTimeout(timer);
        }
        if (firstChoiceType === 'scientifique') {
            const scientificDepts = departments['scientifique'];
            if (!hasAtLeastOneFilierePerDept(choices, scientificDepts)) {
                setControllerChoice(true);
                setPhoto(true);
                setOpen(true);
                setMessage("Vous devez choisir au moins une filière dans chaque département scientifique.");
                return;
            } else {
                setControllerChoice(false);
            }
        } 

}, [choices,controllerChoice]);
 
    const handleSubmit = async (e) => {
        try {
            e.preventDefault();
            const payload = {};
            data.nom = data.nom.trim()
            data.prenom = data.prenom.trim()
            payload.campagne = 'concours'
            const nameFiles = ["releve_bac","copie_carte_id","bulletin_terminal","bulletin_premiere","bulletin_seconde","bulletin_terminal2","bulletin_premiere2","bulletin_seconde2"]
            // for (const i in nameFiles) {
            //     if (selectedFiles[nameFiles[i]].size) {
            //         // console.log('fichier bien rempli')
            //         if ((selectedFiles[nameFiles[i]]).size <= maxFileSize) {
            //             formData.append(nameFiles[i] , selectedFiles[nameFiles[i]])
            //         } else {
            //             // console.log("fichier trop gros");
            //         }
            //     } else {
            //         setPhoto(true);
            //         setOpen(true);
            //         setMessage("le document "+ nameFiles[i]+ " est obligatoire !");
            //         setErrors(true);
            //         return
            //     }
            // }
            for (let key in data) {
                if (data.hasOwnProperty(key)) {
                    if( data[key] !== null || data[key] !== '') {
                        if (data[key] === '' || data[key] === null) {
                            if ((key ==='troisieme_choix_ecole' || key ==='quatrieme_choix_ecole') & (firstChoiceType==='litteraire'))  {
                                data.troisieme_choix_ecole = '';
                                data.quatrieme_choix_ecole = '';
                            } else {
                                setPhoto(true);
                                setOpen(true);
                                setMessage("le champs "+ key + " est obligatoire.");
                                setErrors(true);
                                return
                            }
                        }
                        payload[key] = data[key]
                    } else {
                        // console.log(data[key])
                    }
                }
            }

            // console.log("Champs remplis coorrectement "+fieldsCount)
            if (!valid.isValidPhoneNumber) {
                setMessageAlerte('Incorrect')
                setShow(true);
            }
            else if (!data.serie || !data.premier_choix_ecole ) {
                setPhoto(true);
                setOpen(true);
                setErrors(true);
                setMessage("les choix de filières sont obligatoire");
            }
            else if ((firstChoiceType === 'scientifique') && (data.premier_choix_ecole==='' || data.second_choix_ecole==='' || data.troisieme_choix_ecole==='' || data.quatrieme_choix_ecole==='')) {
                setPhoto(true);
                setOpen(true);
                setMessage("les choix de filières sont obligatoire");
            }
            else if ((firstChoiceType === 'litteraire') && (data.premier_choix_ecole==='' || data.second_choix_ecole==='')) {
                setPhoto(true);
                setOpen(true);
                setMessage("les choix de filières sont obligatoire");
            }
            else if (data.premier_choix_ecole==='true' || data.second_choix_ecole==='false' || data.premier_choix_ecole==='false' || data.second_choix_ecole==='true') {
                setPhoto(true);
                setOpen(true);
                setMessage("les choix de filières sont obligatoire");
            }
            else if  (erreurMoyenne) {
                setPhoto(true);
                setOpen(true);
                setMessage("Une moyenne de 12 est requise en terminale pour ces choix de filières !");
                setErrors(true);
            }
            else {
                setErrors(false)
                setComplete(true)
                setSubmitted(true);
                // console.log("Requete en cours d'envoi ...")
                const response = await axios.post(
                    `${API_URL}/paiement/`,
                    payload);

            if (response.status === 200) {
                setSubmitted(false);
            // console.log("Initialisation Success");
            // console.log('Data from API :', response.data);
            if (response.data.message==='OK') {
                // console.log(response.data)
                setSubmitted(false);
                setPayEmail(data.email);
                setShowPay(true);
                setStep(1);
                setData('');
                if (response.data.paymentURL) {
                    window.location.href = response.data.paymentURL;
                }
            }
            else if (response.data.detail) {
                // console.log(response.data.detail)
                    setSubmitted(false);
                    setOpen(true);
                    setMessage(response.data.detail)
            }
            } else {
                if (response.data.detail) {
                    // console.log(response.data.detail)
                    setSubmitted(false);
                    setOpen(true);
                    setMessage(response.data.detail)
                }
                // console.error('Error uploading files');
            }
        }
    } catch (error) {
        setSubmitted(false);
        setOpen(true)
        setMessage('Impossible de procéder à un paiement !')
    }
};
    const handleUpdate = (e) => {
        setShowUpdate(true)
    }
    const handleConnect = (e) => {
        e.preventDefault();
        window.location.href =`${API_URL}/user/login`
    }

    return (
        <>
        <UpdateDepot showUpdate = {showUpdate} handleCloseUpdate = {handleCloseUpdate} />
        <AlerteMessage open={open} handleClose={handleClose3} message={message} />
        <IdTransaction show={showPay} email={payEmail} handleClose={() =>
            {setShowPay(false)}
            } />
        {depotsuccess ? <RecepisseConcours  dataPerson={succes}/> : null}
        <Container className='pay' id='mainConcours'>
            <div className='d-flex flex-row' id='payHead'>
                {/* <div>
                    <Image src={logo} width={239} height={220} />
                </div> */}
                <div className='' id='texthead' style={{textAlign: 'center'}}>
                    <p>Ecole Supérieure Polytech Diamniadio</p>
                    <h4>Concours - Edition 2026</h4>
                </div>
            </div>
            {auth && (
                <div className="my-4">
            <div className="d-flex justify-content-between align-items-center mt-2" style={{ maxWidth: 500, margin: '0 auto' }}>
                {[1, 2,3].map((num,idx,arr) => (
                    <React.Fragment key={num}>
                <div key={num} className="text-center" style={{ flex: 1 }}>
                    <div
                    style={{
                        width: 36,
                        height: 36,
                        borderRadius: '50%',
                        background: (step === num || step > num) ? '#0d6efd' : '#e9ecef',
                        color: (step === num || step > num) ? '#fff' : '#495057',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto',
                        fontWeight: 'bold',
                        fontSize: 18,
                        border: step === num || step > num ? '2x solid #0d6efd' : '2px solid #e9ecef',
                        boxShadow: step === num || step > num ? '0 0 8px #0d6efd55' : 'none',
                        transition: 'all 0.2s'
                    }}
                    >
                    {num}
                    </div>
                </div>
                    {idx < arr.length - 1 && step > num && (
                        <div style={{ width: 30, height: 2, background: '#0d6efd', margin: '0 2px', alignSelf: 'center' }} />
                        )}
                        {idx < arr.length - 1 && step <= num && (
                        <div style={{ width: 30, height: 2, background: '#e9ecef', margin: '0 2px', alignSelf: 'center' }} />
                        )}
                    </React.Fragment>
                ))}
            </div>
            </div>
            )}
            <div className='homeConcours'>
                <Form onSubmit={handleSubmit} className=''>
                    <div>
                    {step === 1 && (
                        <div id='step1Cncours'>
                            {auth ? <>
                                <div className='p-4 row' id='headInput'>
                                {/* informations personnelles */}
                                <Form.Group className='col-md-6 col-sm-12'>
                                    <Form.Label>Numéro de téléphone </Form.Label>
                                    <Form.Control 
                                        placeholder='Ex 777777777'
                                        size='md'
                                        type='number'
                                        name='telephone'
                                        className='p-2 custom-email-input'
                                        onChange={handleChange}
                                        value={data.telephone || ''}
                                        required
                                    />
                                </Form.Group>
                                <Form.Group className='col-md-6 col-sm-12'>
                                    {user ?
                                    <>
                                    <Form.Label>Adresse Email</Form.Label>
                                    <Form.Control 
                                        placeholder='Email'
                                        size='md'
                                        type='email'
                                        name='email'
                                        value={data.email || ''}
                                        className='p-2 custom-email-input'
                                        // onChange={handleChange}
                                        readOnly
                                        disabled
                                        required
                                    /></>
                                     : 
                                     
                                      null }
                                   
                                    </Form.Group>
                                    <Form.Group className='col-md-6 col-sm-12'>
                                    <Form.Label>Numéro de Table BAC</Form.Label>
                                    <Form.Control 
                                        placeholder='Numéro de Table BAC'
                                        size='md'
                                        type='number'
                                        name='numero_table'
                                        className='p-2 custom-email-input'
                                        onChange={handleChange}
                                        value={data.numero_table || ''}
                                        required
                                    />
                                    </Form.Group>
                                    <Input type='date' className='col-md-6 col-sm-12' label="Date de Naissance" name='date_naissance' value={data.date_naissance || ''} onChange={handleChange} />

                                    <div className="text-secondary">
                                        <p className="text-secondary fw-bold" style={{ fontSize: 13 }}>
                                            Ces informations nous permettent de récupérer vos données en collaboration avec l'Office du Baccalauréat.
                                        </p>
                                        </div>  
                               
                                        </div>
                                        {showMessage && (
                                        <span className={`${valid.isValidPhoneNumber ? 'text-success' : 'text-danger'}`}>
                                            {valid.isValidPhoneNumber ? 'Numéro valide' : 'Numéro incorrect'}
                                        </span>
                                    )}
                                                    {showMessageEmail && (
                                        <span className={`${valid.isValidEmail ? 'text-success' : 'text-danger'}`}>
                                            {valid.isValidEmail ? 'Email valide' : 'Email incorrect'}
                                        </span>
                                    )}
                                            {/* {!valid.isValidPhoneNumber ? <span ><i className='alert alert-success w-25 m-2' >Incorrect</i> </span> : <span className='alert alert-success' >Numéro valide</span>} */}
                                         
                                        <div id="operateur" className="d-flex gap-3 my-3">
                                                {[
                                        { value: 'wave', img: wave, label: 'Wave' },
                                        { value: 'orange-money', img: om, label: 'OM' },
                                        { value: 'free-money', img: yas, label: 'Yas' },
                                        { value: 'e-money', img: expresso, label: 'E-Money' }
                                    ].map(op => (
                                        <span
                                        key={op.value}
                                        variant={data.operateur === op.value ? 'success' : 'outline-secondary'}
                                        onClick={() => setData({ ...data, operateur: op.value })}
                                        style={{
                                            padding: 3,
                                            border: data.operateur === op.value ? '2px solid #00A7E1' : 'none',
                                            borderRadius: 10,
                                            boxShadow: data.operateur === op.value ? '0 0 8px #0d6efd55' : 'none',
                                            width: 100,
                                            height: 100,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: 'pointer',
                                        }}
                                        >
                                        <Image src={op.img} height={70} width={70} alt={op.label} />
                                        <div style={{ fontSize: 13, marginTop: 4 }}>{op.label}</div>
                                        </span>
                                    ))}
                                </div>
                                 <div id="labelFrais">
                                                <p className='text-danger ml-2' id='frais'>Les frais de dossier non remboursables sont de (10 000) F. CFA + frais de 125 F. CFA</p>
                                            </div>
                                
                                 <div className="p-2">
                            </div>
                                </> 
                            :
                            <>
                                <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: 400 }}>
                                    <div className="bg-white shadow rounded p-4" style={{ maxWidth: 400, width: '100%' }}>
                                        <div className="text-center mb-3">
                                            <Image src={logo} width={80} height={80} alt="Logo UAM" className="mb-2" />
                                            <h4 className="fw-bold mb-2">Bienvenue sur la plateforme concours</h4>
                                            <p className="text-muted mb-4" style={{ fontSize: 16 }}>
                                                Connectez-vous pour postuler au concours d'entrée à l'Ecole Supérieure Polytech Diamniadio.
                                            </p>
                                        </div>
                                        <Button
                                            variant="primary"
                                            size="lg"
                                            className="w-100 mb-2"
                                            style={{ fontWeight: 'bold', fontSize: 18, letterSpacing: 1 }}
                                            onClick={handleConnect}
                                        >
                                            Se connecter
                                        </Button>
                                        <div className="text-center mt-3">
                                            <span className="text-secondary" style={{ fontSize: 15 }}>
                                                Veuillez remplir le formulaire après connexion pour postuler au concours.
                                            </span>
                                        </div>
                                        <div className="row mt-3 g-2">
    <div className="col-lg-4 col-md-4 col-sm-12 d-flex justify-content-center">
        <a href={guide} download>
            <Button variant="primary" className='w-100' size="md">
                Guide de la plateforme
            </Button>
        </a>
    </div>
    <div className="col-lg-4 col-md-4 col-sm-12 d-flex justify-content-center">
        <a href={brochure} download>
            <Button variant="primary" className='w-100' size="md">
                Brochure POLYTECH
            </Button>
        </a>
    </div>
    <div className="col-lg-4 col-md-4 col-sm-12 d-flex justify-content-center">
        <Button variant="warning" className='w-100' size="md" onClick={handleUpdate}>
            Modifier sa candidature
        </Button>
    </div>
</div>
                                        </div>
                                            </div>
                            </>}
                        </div>)}
                        
                </div>
                    {/* fin de step 1 */}
                    {step === 2 && (
                        <div id="step2Pay">
                            <div className="head">
                                <span className='text-bold'>Informations personnellles Candidat</span> 
                            </div>
                           <div className='row infosPerso' id='test'>
                                <Form.Group>
                                    <div className='d-inline'>
                                        <Form.Check
                                        inline
                                                type="radio"
                                                label="Monsieur"
                                                value="M"
                                                required
                                                checked={data.civilite==='M'}
                                                name="civilite"
                                                onChange={handleChange}
                                                disabled={true}
                                            />
                                    </div>
                                    <div className='d-inline'>
                                            <Form.Check
                                            checked={data.civilite==='F'}
                                                inline
                                                type="radio"
                                                label="Madame"
                                                value="F"
                                                required
                                                disabled={true}
                                                name="civilite"
                                                onChange={handleChange}
                                            />
                                    </div>
                                </Form.Group>
                            <div>
                            </div>
                                <Input className="col-md-6 col-sm-12" disabled={true} value={data.prenom || ''}  type='text' label="Prénom (s)" name='prenom' onChange={handleChange} />
                                <Input className="col-md-6 col-sm-12" disabled={true} value={data.nom || ''}   type='text' label="Nom" name='nom' onChange={handleChange}/>
                                {older ? <span style={{color:'red'}}>Le concours est ouvert aux bacheliers de la session 2025, âgés de 22 ans tout au plus au 31
                                    décembre 2024. </span>: null}
                                {/* <Input type='text' className='col-md-6 col-sm-12' label="Pays de Naissance" name='pays' value={data.pays} onChange={handleChange} /> */}
                                <Input type='text' className='col-md-6 col-sm-12' label="Lieu de naissance" disabled={true} name='lieu_naissance' value={data.lieu_naissance} onChange={handleChange} />
                                 <div className='col-md-6 col-sm-12'>
                                    <Input className="col-md-6 col-sm-12" disabled={true} value={bacSerie}   type='text' label="Série de BAC:" name='serie' onChange={handleChange}/>
                                    {/* <label className="form-label fw-medium">Série de BAC:</label>
                                    <select value={bacSerie} disabled  className='form-select'>
                                        <option value="">Série de BAC</option>
                                        {bacSeries.map((serie) => (
                                            <option className='t' key={serie} value={serie}>{serie}</option>
                                        ))}
                                    </select> */}
                                </div>
                                <Form.Group className='col-md-6 col-sm-12'>
                                    {/* <Form.Label className='fw-medium'>Session au BAC <span style={{color:'red'}}>*</span> </Form.Label> */}
                                    <Input className="col-md-6 col-sm-12" disabled={true} value={data.session === "1" ? 'Premier Tour' : data.session === "2" ? 'Deuxième Tour' : ''}   type='text' label="Session au BAC" name='session' onChange={handleChange}/>
                                    {/* <Form.Select name='session' disabled required value={data.session} onChange={handleChange}>
                                        <option value="">Sélectionner  ...</option>
                                        <option value="Normale">Premier Tour</option>
                                        <option value = "Second">Deuxième Tour</option>
                                    </Form.Select> */}
                                </Form.Group>
                                <Input className="col-md-6 col-sm-12" type='number' disabled={true} min={0} max={20} label="Moyenne BAC - 1er Tour" name='moyenne_bac' value={data.moyenne_bac} onChange={handleChange} />
                                <InputT className="col-md-6 col-sm-12 " type='number' disabled={true} min={0} label="Numéro de Table de BAC" name='numero_table' value={data.numero_table} onChange={handleChange} />
                                <Input className="rounded-left mb-2 col-md-6 col-sm-12" disabled={true} label="Lycée ou école d'origine" type='text' name='lycee_ecole' value={data.lycee_ecole} onChange={handleChange} />
                                {/* <Form.Group className="col-md-6 col-sm-12" id="">
                                    <Form.Label className='fw-medium'>Nationalité<span style={{color:'red'}}>*</span></Form.Label>
                                    <Form.Select name='nationnalite' required value={data.nationnalite} onChange={handleChange}>
                                    <option key="" value="">--- Selectionner ---</option>
                                        {nationalities.map((nationnality,index) =>
                                            <option key={index}>{nationnality}</option>
                                        )}
                                    </Form.Select>
                                </Form.Group> */}
                                {/* <Input className="rounded-left mb-2 col-md-6 col-sm-12" type='text' label="Ville" name='ville' value={data.ville} onChange={handleChange} /> */}
                            </div>
                            <div className="row">
                                
                            </div>
                            </div>)}
                             {/* {step === 3 && (
                                <div id="step3">
                            <div className="head">
                                <span className='text-bold' >Informations d'études</span> 
                            </div>
                            <div >
                            {/* <Form.Group>
                                <Form.Label className='fw-medium'>Région <span style={{color:'red'}}>*</span></Form.Label>
                                <Form.Select name='region' required value={data.region} onChange={handleChange}>
                                    <option value="">--- Choisir une région ---</option>
                                    <option>Dakar</option>
                                    <option>Kaolack</option>
                                    <option>Thies</option>
                                    <option>Diourbel</option>
                                    <option>Saint-Louis</option>
                                    <option>Louga</option>
                                    <option>Ziguinchor</option>
                                    <option>Matam</option>
                                    <option>Kaffrine</option>
                                    <option>Fatick</option>
                                    <option>Kolda</option>
                                    <option>Kedougou</option>
                                    <option>Tambacounda</option>
                                    <option>Sédhiou</option>
                                </Form.Select>
                            </Form.Group>
                                <Form.Group>
                                    <Form.Label className='fw-medium'>Département <span style={{color:'red'}}>*</span></Form.Label>
                                    <Form.Select name='departement' value={data.departement} required onChange={handleChange}>
                                    <option value="">--- Choisir un département ---</option>
                                    {data.region ==="Kaolack" ?
                                        <>
                                        <option>Kaolack</option>
                                        <option>Guinguénéo</option>
                                        <option>Nioro Du Rip</option>
                                        </>
                                    : null}
                                    {data.region ==="Dakar" ?
                                        <>
                                        <option>Dakar</option>
                                        <option>Guediawaye</option>
                                        <option>Pikine</option>
                                        <option>Keur Massar</option>
                                        <option>Rufisque</option>
                                        </>
                                    : null}
                                    {data.region ==="Thies" ?
                                        <>
                                        <option>Thies</option>
                                        <option>Tivaouane</option>
                                        <option>Mbour</option>
                                        </>
                                    : null}
                                    {data.region ==="Diourbel" ?
                                        <>
                                        <option>Diourbel</option>
                                        <option>Bambey</option>
                                        <option>Mbacke</option>
                                        </>
                                    : null}
                                    {data.region ==="Saint-Louis" ?
                                        <>
                                        <option>Saint-Louis</option>
                                        <option>Podor</option>
                                        <option>Dagana</option>
                                        </>
                                    : null}
                                    {data.region ==="Louga" ?
                                        <>
                                        <option>Louga</option>
                                        <option>Kébémer</option>
                                        <option>Linguère</option>
                                        </>
                                    : null}
                                    {data.region ==="Ziguinchor" ?
                                        <>
                                        <option>Ziguinchor</option>
                                        <option>Oussouye</option>
                                        <option>Bignona</option>
                                        </>
                                    : null}
                                    {data.region ==="Matam" ?
                                        <>
                                        <option>Matam</option>
                                        <option>Kanel</option>
                                        <option>Ranérou</option>
                                        </>
                                    : null}
                                    {data.region ==="Kaffrine" ?
                                        <>
                                        <option>Kaffrine</option>
                                        <option>Birkilane</option>
                                        <option>Koungheul</option>
                                        <option>Malem Hodar</option>
                                        </>
                                    : null}
                                    {data.region ==="Fatick" ?
                                        <>
                                        <option>Fatick</option>
                                        <option>Gossas</option>
                                        <option>Foundiougne</option>
                                        </>
                                    : null}
                                    {data.region ==="Kolda" ?
                                        <>
                                        <option>Kolda</option>
                                        <option>Vélingara</option>
                                        <option>Médina Yoro Foulah</option>
                                        </>
                                    : null}
                                    {data.region ==="Kedougou" ?
                                        <>
                                        <option>Kedougou</option>
                                        <option>Salemata</option>
                                        <option>Saraya</option>
                                        </>
                                    : null}
                                    {data.region ==="Tambacounda" ?
                                        <>
                                        <option>Tambacounda</option>
                                        <option>Koumpentoum</option>
                                        <option>Bakel</option>
                                        <option>Goudiry</option>
                                        </>
                                    : null}
                                    {data.region ==="Sédhiou" ?
                                        <>
                                        <option>Sédhiou</option>
                                        <option>Goudomp</option>
                                        <option>Bounkiling</option>
                                        </>
                                    : null}
                                    </Form.Select>
                                </Form.Group> 
                                <Input className="rounded-left mb-2" label="Lycée ou école d'origine" type='text' name='lycee_ecole' value={data.lycee_ecole} onChange={handleChange} />
                                <Input type='number' max={20} min={ data.serie === 'L2' && (data.premier_choix_ecole === 'HEEG' || data.second_choix_ecole === 'HEEG') ? 12 : 0} label="Moyenne en classe de Terminale" name='moyenne_terminal' value={data.moyenne_terminal} onChange={handleChange} />
                                {(data.serie === 'L2' &&( data.premier_choix_ecole === 'HEEG' || data.second_choix_ecole === 'HEEG' )  && data.moyenne_terminal < 12) ? 
                                    <div style={{ marginTop: '10px' }}>
                                        <span style={{ color: 'red', fontSize: '14px', fontWeight: 'bold' }}>
                                            La moyenne en classe de terminale doit être supérieure ou égale à 12/20 pour postuler à cette école (HEEG).
                                        </span>
                                    </div>
                                    : null
                                }
                                <Input type='number' min={0} max={20} label="Moyenne générale en classe de Première" name='moyenne_premiere' value={data.moyenne_premiere} onChange={handleChange} />
                                <Input type='number' min={0} max={20} label="Moyenne générale en classe de Seconde" name='moyenne_seconde' value={data.moyenne_seconde} onChange={handleChange} />
                                </div>
                            </div> */}
                                {/* Informations au BAC */}
                                {/* {step === 4 && (
                            <div id="step4">
                                <div className="head">
                                    <span className='text-bold'>Informations au BAC</span> 
                                </div>
                                <div className=''>
                                    <label className="form-label fw-medium">Série de BAC:</label>
                                    <select value={bacSerie} className='form-select'>
                                        <option value="">Sélectionner une série</option>
                                        {bacSeries.map((serie) => (
                                            <option className='t' key={serie} value={serie}>{serie}</option>
                                        ))}
                                    </select>
                                </div>
                                <Form.Group>
                                    <Form.Label className='fw-medium'>Session au BAC <span style={{color:'red'}}>*</span> </Form.Label>
                                    <Form.Select name='session' required value={data.session} onChange={handleChange}>
                                        <option value="">Sélectionner  ...</option>
                                        <option value="Normale">Premier Tour</option>
                                        <option value = "Second">Deuxième Tour</option>
                                    </Form.Select>
                                </Form.Group>
                                <Input type='number' min={0} max={20} label="Moyenne BAC - 1er Tour" name='moyenne_bac' value={data.moyenne_bac} onChange={handleChange} />
                                <InputT type='number' min={0} label="Numéro de Table de BAC" name='numero_table' value={data.numero_table} onChange={handleChange} />
                            </div>)} */}
                             {step === 3 && (
                                <div id="step5">
                                <div className="head">
                                <span className='text-bold'>Choix du centre d'examen et des filières</span> 
                                </div>
                                {/* <Input type='text' className='col-md-6 col-sm-12' label="Adresse" name='address' value={data.address} onChange={handleChange} /> */}
                                <Form.Group>
                                <Form.Label className='fw-medium'>Choix du Centre de Concours <span style={{color:'red'}}>*</span></Form.Label>
                                <Select
                                        name="centre_examen"
                                        options={concoursCenters}
                                        value={concoursCenters.find(opt => opt.value === data.centre_examen)}
                                        onChange={option => setData({ ...data, centre_examen: option.value })}
                                        isSearchable={true}
                                        required
                                    />
                                </Form.Group>
                                {data.centre_examen === "Diamniadio (UAM)" && (
                                    <Form.Group>
                                    <Form.Label className='fw-medium'>Département <span style={{color:'red'}}>*</span></Form.Label>
                                    <Select
                                        name="departement"
                                        options={departementsOptions}
                                        value={departementsOptions.find(opt => opt.value === data.departement)}
                                        onChange={option => setData({ ...data, departement: option.value })}
                                        isSearchable={true}
                                        required
                                    />
                                </Form.Group>
                                )}
                                {bacSerie && (
                                    <div className='row border w-100'>
                                        <div className="col-md-8 col-sm-12 ">
                                        <Form.Label className='fw-medium'>Choix de filières<span style={{color:'red'}}>*</span></Form.Label>
                                        <br />
                                        <div id='ChoixFilières'>
                                        {bacSerie && (
                                            <>
                                                {(!firstChoiceType || firstChoiceType === 'scientifique') && renderDepartments('scientifique')}
                                                {(!firstChoiceType || firstChoiceType === 'litteraire') && renderDepartments('litteraire')}
                                            </>
                                        )}
                                        <br />
                                        </div>
                                        </div>
                                        <div className="col col-md-4 col-sm-12 ">
                                        {data.premier_choix_ecole && (
                                        <>
                                        <span>Choix sélectionnés:</span>
                                            <ul>
                                                {orderedChoices.map((choice, index) => (
                                                    <li key={`${choice.filiere}`} className="text text-danger">
                                                        <span >Choix {index + 1}</span> : {choice.filiere}
                                                    </li>
                                                ))}
                                            </ul>
                                        </>
                                        )}
                                    </div>    
                                    </div>
                            )}                               
                            {controllerChoice ? <div className="alert alert-danger" role="alert">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" fill="currentColor" className="bi bi-exclamation-triangle" viewBox="0 0 16 16">
                                <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z"/>
                                <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z"/>
                                </svg> Vous devez choisir au moins une dans chaque département.
                                </div> : 
                            null}
                            {nmbrechoix && (
                            <div className="alert alert-warning" role="alert">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" fill="currentColor" className="bi bi-exclamation-triangle" viewBox="0 0 16 16">
                                    <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z"/>
                                    <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z"/>
                                    </svg> Vous devez choisir au moins deux filières .
                                </div>
                            )}
                         </div>)}
                          {/* {step === 6 && (
                            <div id="step6">
                            <div className="head">
                                <span className='text-bold'>Dossiers à fournirs</span> 
                            </div>
                                <div id="files">
                                    <InputF required={true} className="rounded-left mb-2" label="Copie carte d'identité / copie passport / carte scolaire" type='file' name='copie_carte_id' onChange={(e) => handleFileChange(e,"copie_carte_id")} />
                                    {!selectedFiles["copie_carte_id"]? <span style={{color:'red'}}>taille du fichier {'>'} 1 Mo veuiller le réduire . </span>: null}

                                    <InputF required={true} className="rounded-left mb-2" label="Relevé BAC" type='file' name='releve_bac' onChange={(e) => handleFileChange(e,"releve_bac")} />
                                    {!selectedFiles["releve_bac"]? <span style={{color:'red'}}>taille du fichier {'>'} 1 Mo veuiller le réduire . </span>: null}

                                    <InputF required={true} className="rounded-left mb-2" label="Bulletin terminale premier semestre " type='file' name='bulletin_terminal' onChange={(e) => handleFileChange(e,"bulletin_terminal")} />
                                    {!selectedFiles["bulletin_terminal"]? <span style={{color:'red'}}>taille du fichier {'>'} 1 Mo veuiller le réduire . </span>: null}

                                    <InputF required={true} className="rounded-left mb-2" label="Bulletin terminale deuxieme semestre" type='file' name='bulletin_terminal2' onChange={(e) => handleFileChange(e,"bulletin_terminal2")} />
                                    {!selectedFiles["bulletin_terminal2"]? <span style={{color:'red'}}>taille du fichier {'>'} 1 Mo veuiller le réduire . </span>: null}

                                    <InputF required={true} className="rounded-left mb-2" label="Bulletin Première premier semestre" type='file' name='bulletin_premiere' onChange={(e) => handleFileChange(e,"bulletin_premiere")} />
                                    {!selectedFiles["bulletin_premiere"]? <span style={{color:'red'}}>taille du fichier {'>'} 1 Mo veuiller le réduire . </span>: null}

                                    <InputF required={true}  className="rounded-left mb-2" label="Bulletin Première deuxieme semestre " type='file' name='bulletin_premiere2' onChange={(e) => handleFileChange(e,"bulletin_premiere2")} />
                                    {!selectedFiles["bulletin_premiere2"]? <span style={{color:'red'}}>taille du fichier {'>'} 1 Mo veuiller le réduire . </span>: null}

                                    <InputF required={true} className="rounded-left mb-2" label="Bulletin Seconde premier semestre" type='file' name='bulletin_seconde' onChange={(e) => handleFileChange(e,"bulletin_seconde")} />
                                    {!selectedFiles["bulletin_seconde"]? <span style={{color:'red'}}>taille du fichier {'>'} 1 Mo veuiller le réduire . </span>: null}

                                    <InputF required={true} id="bulletin" className="rounded-left mb-2" label="Bulletin Seconde deuxieme semestre" type='file' name='bulletin_seconde2' onChange={(e) => handleFileChange(e,"bulletin_seconde2")} />
                                    {!selectedFiles["bulletin_seconde2"]? <span style={{color:'red'}}>taille du fichier {'>'} 1 Mo veuiller le réduire . </span>: null}
                                </div>
                        </div>
                    )} */}
                    {/* Fin de step 2 */}
                    {errors ? <><div className="alert alert-danger" role="alert">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" fill="currentColor" className="bi bi-exclamation-triangle" viewBox="0 0 16 16">
                                <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z"/>
                                <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z"/>
                                </svg> Veuiler remplir tous les champs
                            </div></> : null}
                            <div id="buttonsPay">
                    {step > 1 && (
                    <Button variant='primary' className='float-start' size="md" onClick={handlePreviousStep}>Précedent</Button>
                    )}
                    {step < 3 && (
                        <>
                         {auth && (
                            <Button className='float-end mb-2' variant='primary' size="md" onClick={handleNextStep}>Suivant</Button>
                        )}
                        </>
                       
            )}
                    {step === 3 && 
                        <Button
                            size='md'
                            variant='primary' 
                            disabled={!valid.isValidPhoneNumber || !checked  ||  controllerChoice || nmbrechoix}
                            type='submit'
                            role='submit'
                            className ='float-end btn-submit '
                            >
                                {requiredOK ? (<span>Payer avec {data.operateur}</span>)  : <FontAwesomeIcon icon={faBan} className='color-logo' />} 
                                {submitted ? 
                                    <Spinner animation="grow"
                                        size="sm" role="status"
                                    >
                                        <span className="visually-hidden">Loading...</span>
                                    </Spinner> 
                                : null} 
                        </Button> }
                    </div>
                </Form>
            </div>
        </Container>
        </>
    )
}
export default Pay